export const licenseDevextreme = import.meta.env.VITE_LICENSE_DEVEXTREME;
export const publicApiEndpoint = import.meta.env.VITE_API_URL;
export const b2bApiEndpoint = import.meta.env.VITE_API_B2B_URL;